module.exports = __webpack_public_path__ + "static/media/07_before.667cbdda.jpg";